export type TTransactions = {
    id: string;
    amount: string;
    feeAmount: string;
    totalAmount: string;
    createdAt: string;
    updatedAt: string;
    userId: string;
    nexId: string;
    merchantId: string;
    type: ETransactionType;
    operationType: EOperationType;
    status: ETransactionStatus;
    meta: TTransactionsMeta;
    merchantTransactionId: string | null;
    uniqueTransactionId: string | null;
    referenceNo: string | null;
};

export type TTransactionsMeta = {
    fromDebitCardId: string;
    fromDirectDebitCardId: string;
    bankName: string;
    accountName: string;
    accountNumber: string;
    rejectReason: string;
    cardType: string;
    cardChannelCode: string;
    cardLastFour: string;
    receiverNexId: string;
    phone: string;
    turnover: string;
    walletBalance: string;
    beneficiary_bank_code: string | null;
    beneficiary_bank_name: string | null;
    beneficiary_account_name: string | null;
    beneficiary_account_number: string | null;
    qrMerchantName: string | null
    qrMerchantCity: string | null
    qrMerchantPan: string | null
    qrAmount: string | null
    qrFee: string | null
    orderSubMerchantName: string | null
};

export enum OrderPosition {
    FORWARD = 'forward',
    BACKWARD = 'backward',
}

export type TSetWithdrawStatusParams = {
    transactionId: string;
    status: EWithdrawStatusSet; // 1 - rejected, 2 - completed
    rejectReason?: string;
};

export enum EProviderIds {
    'AXIS' = 0,
    'INDOSAT' = 1,
    'TELKOMSEL' = 2,
    'XL' = 3,
}
export const EDenominationIds = [25000, 50000, 75000, 100000];

export type TSetPulsaStatusParams = {
    transactionId: string;
    status: EWithdrawStatusSet; // 1 - rejected, 2 - completed
    // userId: string;
    // phone: string;
    // providerId: EProviderIds;
    // denominationId?: number;
};

export type TSetTopUpStatusParams = {
    transactionId: string;
    status: EWithdrawStatusSet; // 1 - rejected, 2 - completed
    rejectReason?: string;
};

export type TSetTransactionStatusParams = {
    transactionId: string;
    status: EWithdrawStatusSet; // 1 - rejected, 2 - completed
    rejectReason?: string;
    type: string;
};

export enum EWithdrawStatusSet {
    REJECTED = 1,
    COMPLETED = 2,
}

export enum ETransactionType {
    TOP_UP = '0',
    DEBIT = '1',
    DIRECT_DEBIT = '2',
    WITHDRAW = '3',
    WALLET = '4',
    PULSA = '5',
    INTERBANK = '6',
    PAYMENT = '7',
    QR_PAYMENT = '8',
    QR_PAYMENT_REFUND = '9',
}

export enum EOperationType {
    INCOME = '0',
    OUTCOME = '1',
}

export enum ETransactionStatus {
    PENDING = '0',
    REJECTED = '1',
    COMPLETED = '2',
}

export interface BankDetail {
    bank_id: string;
    bank_name: string;
}

export interface IGetTransactionsFilter {
    fromDate: string;
    toDate: string;
    status: string;
    type: string;
    nexId: string;
    referenceNo: string;
    orderBy: string;
    orderAsc: string;
}

export const BankList: Record<string, BankDetail> = {
    '110': {
        bank_id: '1100462',
        bank_name: 'BPD JAWA BARAT DAN BANTEN',
    },
    '111': {
        bank_id: '1110290',
        bank_name: 'DKI',
    },
    '112': {
        bank_id: '1120060',
        bank_name: 'BPD YOGYAKARTA',
    },
    '113': {
        bank_id: '1139925',
        bank_name: 'BPD JAWA TENGAH',
    },
    '114': {
        bank_id: '1140383',
        bank_name: 'JATIM',
    },
    '116': {
        bank_id: '1160130',
        bank_name: 'ACEH',
    },
    '117': {
        bank_id: '1179930',
        bank_name: 'BPD SUMATERA UTARA',
    },
    '118': {
        bank_id: '1180275',
        bank_name: 'BPD SUMATERA BARAT',
    },
    '119': {
        bank_id: '1190524',
        bank_name: 'BPD RIAU KEPRI',
    },
    '120': {
        bank_id: '1200061',
        bank_name: 'BPD SUMATERA SELATAN',
    },
    '124': {
        bank_id: '1249938',
        bank_name: 'BPD KALIMANTAN TIMUR',
    },
    '125': {
        bank_id: '1250040',
        bank_name: 'BPD KALTENG',
    },
    '126': {
        bank_id: '1260124',
        bank_name: 'SULSELBAR',
    },
    '127': {
        bank_id: '1270091',
        bank_name: 'BPD SULAWESI UTARA',
    },
    '128': {
        bank_id: '1280065',
        bank_name: 'BPD NTB',
    },
    '129': {
        bank_id: '1290107',
        bank_name: 'BPD BALI',
    },
    '130': {
        bank_id: '1300178',
        bank_name: 'BPD NTT',
    },
    '131': {
        bank_id: '1310171',
        bank_name: 'BPD MALUKU',
    },
    '132': {
        bank_id: '1320161',
        bank_name: 'BPD PAPUA',
    },
    '135': {
        bank_id: '1350076',
        bank_name: 'BPD SULAWESI TENGGARA',
    },
    '137': {
        bank_id: '5580143',
        bank_name: 'BANTEN',
    },
    '145': {
        bank_id: '1450125',
        bank_name: 'NUSANTARA PARAHYANGAN',
    },
    '146': {
        bank_id: '1460063',
        bank_name: 'INDIA INDONESIA',
    },
    '147': {
        bank_id: '1470480',
        bank_name: 'MUAMALAT INDONESIA',
    },
    '151': {
        bank_id: '1510117',
        bank_name: 'MESTIKA DHARMA',
    },
    '152': {
        bank_id: '1520039',
        bank_name: 'SHINHAN INDONESIA',
    },
    '153': {
        bank_id: '1539923',
        bank_name: 'SINARMAS',
    },
    '157': {
        bank_id: '1570128',
        bank_name: 'MASPION INDONESIA',
    },
    '161': {
        bank_id: '1610046',
        bank_name: 'GANESHA',
    },
    '164': {
        bank_id: '1640126',
        bank_name: 'ICBC INDONESIA',
    },
    '167': {
        bank_id: '1670141',
        bank_name: 'QNB INDONESIA',
    },
    '200': {
        bank_id: '2003092',
        bank_name: 'TABUNGAN NEGARA',
    },
    '212': {
        bank_id: '2120108',
        bank_name: 'HIMPUNAN SAUDARA',
    },
    '213': {
        bank_id: '2130554',
        bank_name: 'BTPN',
    },
    '405': {
        bank_id: '4050085',
        bank_name: 'VICTORIA SYARIAH',
    },
    '422': {
        bank_id: '4220080',
        bank_name: 'SYARIAH BRI',
    },
    '425': {
        bank_id: '4250063',
        bank_name: 'BPD JAWA BARAT DAN BANTEN UUS',
    },
    '426': {
        bank_id: '4260969',
        bank_name: 'MEGA TBK',
    },
    '427': {
        bank_id: '4270292',
        bank_name: 'BNI SYARIAH',
    },
    '441': {
        bank_id: '4410489',
        bank_name: 'BUKOPIN',
    },
    '451': {
        bank_id: '4511003',
        bank_name: 'SYARIAH MANDIRI',
    },
    '459': {
        bank_id: '4590040',
        bank_name: 'BISNIS INTERNASIONAL',
    },
    '466': {
        bank_id: '4660196',
        bank_name: 'ANDARA',
    },
    '472': {
        bank_id: '4720014',
        bank_name: 'JASA JAKARTA',
    },
    '484': {
        bank_id: '4840046',
        bank_name: 'KEB HANA',
    },
    '485': {
        bank_id: '4850159',
        bank_name: 'MNC INTERNATIONAL',
    },
    '490': {
        bank_id: '4900096',
        bank_name: 'YUDHA BAKTI',
    },
    '491': {
        bank_id: '4910044',
        bank_name: 'MITRANIAGA',
    },
    '494': {
        bank_id: '4940085',
        bank_name: 'AGRONIAGA',
    },
    '498': {
        bank_id: '4980061',
        bank_name: 'SBI INDONESIA',
    },
    '501': {
        bank_id: '5010024',
        bank_name: 'ROYAL INDONESIA',
    },
    '503': {
        bank_id: '5030101',
        bank_name: 'NOBU NATIONAL BANK',
    },
    '506': {
        bank_id: '5060184',
        bank_name: 'MEGA SYARIAH',
    },
    '513': {
        bank_id: '5130085',
        bank_name: 'INA PERDANA',
    },
    '517': {
        bank_id: '5170032',
        bank_name: 'PANIN SYARIAH',
    },
    '520': {
        bank_id: '5200070',
        bank_name: 'PRIMA MASTER',
    },
    '521': {
        bank_id: '5210099',
        bank_name: 'SYARIAH BUKOPIN',
    },
    '523': {
        bank_id: '5230024',
        bank_name: 'SAHABAT SAMPOERNA',
    },
    '526': {
        bank_id: '5260023',
        bank_name: 'DINAR INDONESIA',
    },
    '531': {
        bank_id: '5310038',
        bank_name: 'AMAR INDONESIA',
    },
    '535': {
        bank_id: '5350043',
        bank_name: 'KESEJAHTERAAN EKONOMI',
    },
    '536': {
        bank_id: '5360075',
        bank_name: 'BCA SYARIAH',
    },
    '542': {
        bank_id: '5420025',
        bank_name: 'ARTOS INDONESIA',
    },
    '547': {
        bank_id: '5470017',
        bank_name: 'BTPN SYARIAH',
    },
    '548': {
        bank_id: '5480010',
        bank_name: 'MULTI ARTA SENTOSA',
    },
    '553': {
        bank_id: '5530025',
        bank_name: 'MAYORA',
    },
    '555': {
        bank_id: '5550128',
        bank_name: 'INDEX SELINDO',
    },
    '559': {
        bank_id: '5590188',
        bank_name: 'CENTRATAMA NASIONAL',
    },
    '562': {
        bank_id: '5620029',
        bank_name: 'FAMA INTERNASIONAL',
    },
    '564': {
        bank_id: '86079',
        bank_name: 'MANDIRI TASPEN',
    },
    '566': {
        bank_id: '5660018',
        bank_name: 'VICTORIA INTERNATIONAL',
    },
    '567': {
        bank_id: '5670053',
        bank_name: 'HARDA INTERNASIONAL',
    },
    '945': {
        bank_id: '9450305',
        bank_name: 'AGRIS',
    },
    '949': {
        bank_id: '9490307',
        bank_name: 'CTBC INDONESIA',
    },
    '950': {
        bank_id: '9500297',
        bank_name: 'COMMONWEALTH',
    },
    '014': {
        bank_id: '142874',
        bank_name: 'CENTRAL ASIA',
    },
    '008': {
        bank_id: '86079',
        bank_name: 'MANDIRI',
    },
    '002': {
        bank_id: '29638',
        bank_name: 'RAKYAT INDONESIA',
    },
    '009': {
        bank_id: '99817',
        bank_name: 'BNI',
    },
    '011': {
        bank_id: '119988',
        bank_name: 'DANAMON',
    },
    '019': {
        bank_id: '190648',
        bank_name: 'PANIN',
    },
    '040': {
        bank_id: '400309',
        bank_name: 'BANGKOK',
    },
    '061': {
        bank_id: '610089',
        bank_name: 'ANZ INDONESIA',
    },
    '037': {
        bank_id: '370374',
        bank_name: 'ARTHA GRAHA',
    },
    '057': {
        bank_id: '570019',
        bank_name: 'BNP PARIBAS INDONESIA',
    },
    '076': {
        bank_id: '760162',
        bank_name: 'BUMI ARTA INDONESIA',
    },
    '054': {
        bank_id: '540308',
        bank_name: 'CAPITAL INDONESIA',
    },
    '046': {
        bank_id: '460307',
        bank_name: 'DBS INDONESIA',
    },
    '016': {
        bank_id: '169983',
        bank_name: 'MAYBANK INDONESIA',
    },
    '097': {
        bank_id: '970237',
        bank_name: 'MAYAPADA',
    },
    '048': {
        bank_id: '99817',
        bank_name: 'MIZUHO INDONESIA',
    },
    '028': {
        bank_id: '281021',
        bank_name: 'OCBC NISP',
    },
    '069': {
        bank_id: '690301',
        bank_name: 'BANK OF CHINA INDONESIA',
    },
    '042': {
        bank_id: '420321',
        bank_name: 'THE BANK OF TOKYO MITSUBISHI UFJ LTD',
    },
    '089': {
        bank_id: '890456',
        bank_name: 'RABO BANK INTERNATIONAL',
    },
    '047': {
        bank_id: '470054',
        bank_name: 'RESONA PERDANIA BANK',
    },
    '045': {
        bank_id: '450304',
        bank_name: 'SUMITOMO MITSUI',
    },
    '023': {
        bank_id: '230715',
        bank_name: 'UOB INDONESIA',
    },
    '068': {
        bank_id: '2120108',
        bank_name: 'WOORI SAUDARA INDONESIA 1906',
    },
    '031': {
        bank_id: '310376',
        bank_name: 'CITIBANK',
    },
    '067': {
        bank_id: '670016',
        bank_name: 'DEUTSCHE AG',
    },
    '087': {
        bank_id: '410360',
        bank_name: 'HSBC',
    },
    '032': {
        bank_id: '320308',
        bank_name: 'JP MORGAN CHASE BANK',
    },
    '050': {
        bank_id: '500306',
        bank_name: 'STANDARD CHARTERED BANK',
    },
    '020': {
        bank_id: '9500297',
        bank_name: 'ARTA NIAGA KENCANA',
    },
    '022': {
        bank_id: '221902',
        bank_name: 'CIMB NIAGA',
    },
    '052': {
        bank_id: '520302',
        bank_name: 'THE ROYAL BANK OF SCOTLAND NV',
    },
    '095': {
        bank_id: '950299',
        bank_name: 'JTRUST',
    },
    '036': {
        bank_id: '360300',
        bank_name: 'CHINA CONSTRUCTION BANK',
    },
};
